export enum SortDirection {
  Ascending = "ASC",
  Descending = "DESC",
}
